import { render, staticRenderFns } from "./L0Nav.vue?vue&type=template&id=218f48b9&"
import script from "./L0Nav.vue?vue&type=script&lang=ts&"
export * from "./L0Nav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports